import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const settings = await fetch('/api/settings').then(res => res.json());
const defaultLanguage = settings.defaultLanguage;

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: defaultLanguage,
  resources: {
    en: {
      translations: require('./locales/en/translations.json')
    },
    no: {
      translations: require('./locales/no/translations.json')
    },
    sv: {
        translations: require('./locales/sv/translations.json')
    }
  },
  ns: ['translations'],
  defaultNS: 'translations'
});

i18n.languages = ['en', 'no', 'sv'];

export default i18n;